<div style="height:400px"
     [style.height.px]="height"
     leaflet
     [leafletOptions]="options"
     [leafletLayers]="layers"
     [leafletMarkerCluster]="markerClusterData"
     [leafletMarkerClusterOptions]="markerClusterOptions">
</div>
